import { useMemo } from 'react';

import { useSupportedLocales } from '../useSupportedLocales';

export const useSupportedBrowserLocale = () => {
  const { supportedLocaleIds } = useSupportedLocales();

  return useMemo(() => {
    const browserLocaleSplitArray = navigator.language.split('-');

    if (browserLocaleSplitArray.length > 1) {
      return navigator.language;
    }

    return supportedLocaleIds.find(locale => {
      if (!locale) return false;

      const localeSplitArray = locale.split('-');

      return localeSplitArray[0] === browserLocaleSplitArray[0];
    });
  }, [supportedLocaleIds]);
};
